import React, { ReactNode } from "react";
import { IntlProvider } from "react-intl";
import { useSelector } from "react-redux";

import { DEFAULT_LOCALE } from "common/static/regions";

import { getLocale, getUserLanguageCode } from "features/regions/selectors";

import dictionaries from "./dictionaries";
import useSetDateFnsLocale from "./useSetDateFnsLocale";
import useSetLocalizeLanguage from "./useSetLocalizeLanguage";

export default function LocalisationProvider({
  children
}: {
  children: ReactNode;
}) {
  const languageCode = useSelector(getUserLanguageCode);
  const locale = useSelector(getLocale);

  useSetDateFnsLocale();
  useSetLocalizeLanguage();

  return (
    // @ts-expect-error - can remove when react-intl is upgraded
    <IntlProvider
      locale={locale}
      messages={dictionaries[languageCode]}
      defaultLocale={DEFAULT_LOCALE}
    >
      {children}
    </IntlProvider>
  );
}
